import {Injectable} from '@angular/core';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';

@Injectable()
export class UrlParamService {
  private params = {};
  private location: Location;
  constructor(location: Location) {
    this.location = location;
  }

  get(key: string): any {
    return this.params[key];
  }

  hasParam(key: string): boolean {
    return typeof (this.params[key]) !== 'undefined';
  }

  setParam(key: string, value: string): void {
    if (typeof (key) !== 'undefined' && key.length > 0) {
      this.params[key] = decodeURIComponent(value);
    }
  }

  setParamAndUpdate(key: string, value: string): void {
    this.setParam(key, value);

    //  this.location.go(this.location.normalize(this.location.path()).split("?")[0] + "?" + this.getUrlWithParams());
  }

  getUrlWithParams(): string {
    let result = '';
    let i = 0;
    for (const param in this.params) {
      if (i > 0) {
        result += '&';
      }
      result += param + '=' + this.params[param];
      i++;
    }
    return result;
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/utils/url-param.service.ts